import Vue from 'vue'
import Router from 'vue-router'
import About from 'components/About'
import Login from 'components/system/Login'
import Role from 'components/system/Role'
import Account from 'components/system/Account'
import Passwd from 'components/system/Passwd'
import Permission from 'components/system/Permission'
import ApiAcs from 'components/system/ApiAcs'
import UserProfile from 'components/system/UserProfile'
import Lock from 'components/Lock'
import Lift from 'components/Lift'
import LiftCallButton from 'components/LiftCallButton'
import Addr from 'components/Addr'
import MonitorLog from 'components/MonitorLog'
import TestBulma from 'components/TestBulma'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/',
      name: 'About',
      component: About
    },
    {
      path: '/login',
      name: 'login',
      component: Login
    },
    {
      path: '/role',
      name: 'role',
      component: Role
    },
    {
      path: '/account',
      name: 'account',
      component: Account
    },
    {
      path: '/pwd',
      name: 'pwd',
      component: Passwd
    },
    {
      path: '/permission',
      name: 'permission',
      component: Permission
    },
    {
      path: '/apiacs',
      name: 'apiacs',
      component: ApiAcs
    },
    {
      path: '/userprofile',
      name: 'userprofile',
      component: UserProfile
    },
    {
      path: '/lock',
      name: 'lock',
      component: Lock
    },
    {
      path: '/lift',
      name: 'lift',
      component: Lift
    },
    {
      path: '/liftbtn',
      name: 'liftbtn',
      component: LiftCallButton
    },
    {
      path: '/addr',
      name: 'addr',
      component: Addr
    },
    {
      path: '/log',
      name: 'MonitorLog',
      component: MonitorLog
    },
    {
      path: '/testbulma',
      name: 'TestBulma',
      component: TestBulma
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js